import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link,useParams } from 'react-router-dom';
import '../sass/about.sass';
import me from '../img/me.jpg'

function About() {
  const { t } = useTranslation();
  const { lng } = useParams();

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <div className='container'>
      <h1 className='text-center mb-50'>{t('About')}</h1>
      <div className='aboutContainer mb-50'>
        <img src={me} alt="Tanjster" />
        <div className='aboutInner'>
          <p>{t('aboutMeTxt')}</p>
          <p><Trans i18nKey="aboutMeTxt2"></Trans></p>
          <p>{t('enough')}</p>
          <Link className='btn btn-link my-20' to={`/${lng}/${t("contact")}`}>{t('heroBtn')}</Link>
          <p>
            <Trans i18nKey="followMe">
              Follow me on <Link className='link' to="https://hr.linkedin.com/in/tatjanatandaric7" target="_blank">Linkedin</Link>
            </Trans></p>
        </div>
      </div>
    </div>
  );
}

export default About;